/*
 * @Author: ningbo.kang
 * @Date: 2020-05-16 10:41:07
 * @LastEditors: wenpan.cao@ecarxgroup.com
 * @LastEditTime: 2023-06-12 16:54:08
 * @Description: 描述
 */

import wgForm from './components/wg-form';
import baseMixin from './components/wg-form/lib/baseMixin';
import props from './components/wg-form/lib/props';
import util from './components/wg-form/lib/util';
import widgetOptions from './components/wg-form/lib/widgetOptions';

// 多语言
import zhCN from './components/wg-form/locale/lang/zh-CN';
import enUS from './components/wg-form/locale/lang/en-US';

// 导出每个组件内部，给表单设计器使用
export {
  // container
  wgForm,
  wgList,
  wgGrid,
  // items
  wgBlank,
  wgCascader,
  wgDivider,
  wgFileupload,
  wgInput,
  wgHidden,
  wgHtml,
  wgLink,
  wgNumber,
  wgTextarea,
  wgText,
  wgSlider,
  wgSwitch,
  wgRadio,
  wgCheckbox,
  wgSelect,
  wgRate,
  wgDate,
  wgDateRange,
  wgTime,
  wgTable,
  wgTreeSelect,
  wgDialog,
  wgProcessSelect,
  wgCompute,
} from './components/wg-form/widget';

export const locale = {
  zh_CN: zhCN,
  en_US: enUS,
};
export {
  baseMixin, props, util, widgetOptions,
};
export default wgForm;
